// @material-ui/core
import {
  Avatar,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography
} from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
// @material-ui/icons
import {
  Apps as AppIcon,
  Book as BookIcon,
  ChildCare as ChildCareIcon
} from "@material-ui/icons";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Caba from "../../services/Caba";

const styles = theme => ({
  count: { textAlign: "right" },
  avatar: {
    backgroundColor: "#4285F4"
  }
});

class DashboardCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      loading: true
    };

    props.toggleLoading(true);
    // get the amount of apps
    Caba.get("/api/v1/" + props.slug).then(response => {
      this.props.toggleLoading(false);
      this.setState({ count: response.data.length, loading: false });
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <Card>
        <CardContent>
          {this.state.loading ? (
            <CircularProgress />
          ) : (
            <Grid container alignItems={"center"}>
              <Grid item xs={4} md={3}>
                <Avatar
                  aria-label={this.state.title}
                  className={classes.avatar}>
                  {this.props.slug === "customers" && <ChildCareIcon />}
                  {this.props.slug === "apps" && <AppIcon />}
                  {this.props.slug === "licenses" && <BookIcon />}
                </Avatar>
              </Grid>
              <Grid item xs={4} md={4}>
                <Typography variant="title">{this.props.title}</Typography>
                <Typography variant="subheading">
                  {this.props.subtitle}
                </Typography>
              </Grid>
              <Grid item xs={4} md={4}>
                <Typography variant="title" className={classes.count}>
                  {this.state.count}
                </Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    );
  }
}

DashboardCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(DashboardCard);



// WEBPACK FOOTER //
// ./src/library/card/DashboardCard.js